const mockTeamAbsences = [
  {
    id: "ta-1",
    machineId: "V26-6336",
    startDate: "2026-02-26",
    endDate: "2026-02-27",
    reason: "Treinamento",
  },
  {
    id: "ta-2",
    machineId: "V25-6335",
    startDate: "2026-03-05",
    endDate: "2026-03-05",
    reason: "Afastamento",
  },
];

export default mockTeamAbsences;
